import { render, staticRenderFns } from "./travel-tourism.vue?vue&type=template&id=4f5a8daa&scoped=true&"
import script from "./travel-tourism.vue?vue&type=script&lang=js&"
export * from "./travel-tourism.vue?vue&type=script&lang=js&"
import style0 from "./travel-tourism.vue?vue&type=style&index=0&id=4f5a8daa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5a8daa",
  null
  
)

export default component.exports